import { ETourId, type ITourConfig } from '../types';

/**
 * Tour shown when the user first views an action item detail page.
 *
 * Two steps:
 * 1. Get the full context — the left panel with overview/details tabs and impacted runs
 * 2. Take action — the right resolution card panel
 */
export const guidanceCenterActionItemTour: ITourConfig = {
  id: ETourId.GUIDANCE_CENTER_ACTION_ITEM,
  steps: [
    {
      id: 'action-item-context-panel',
      target: '[data-tour-id="action-item-context-panel"]',
      titleKey: 'tours.actionItemView.contextPanel.title',
      descriptionKey: 'tours.actionItemView.contextPanel.description',
      position: 'bottomLeft',
    },
    {
      id: 'action-item-resolution-panel',
      target: '[data-tour-id="action-item-resolution-panel"]',
      titleKey: 'tours.actionItemView.resolutionPanel.title',
      descriptionKey: 'tours.actionItemView.resolutionPanel.description',
      finishLabelKey: 'tours.actionItemView.resolutionPanel.finishLabel',
      position: 'leftTop',
    },
  ],
  namespace: 'tours',
  variant: 'default',
  size: 'sm',
  analytics: {
    enabled: true,
    eventPrefix: 'tour_guidance_center_action_item',
    metadata: {
      tourName: 'Guidance Center Action Item',
    },
  },
  persistence: {
    strategy: 'localStorage',
  },
};
